var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-resultsDropdown d-flex gap-1 align-items-center"},[_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(_vm.text)+":")]),_c('the-dropdown',{staticClass:"mb-0",attrs:{"options":_vm.options,"selectedOption":_vm.perPage.toString()},on:{"onChange":function($event){return _vm.setResults($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }